var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.855,
    height: 18,
    viewBox: "0 0 3.9304 4.7625",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.956 -77.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.166 77.386a0.67492 0.67492 0 0 0-0.67949 0.61749 0.67492 0.67492 0 0 0 0.09325 0.40286l-1.5036 1.1288a0.67492 0.67492 0 0 0-0.44457-0.16769 0.67492 0.67492 0 0 0-0.67488 0.67488 0.67492 0.67492 0 0 0 0.67488 0.67488 0.67492 0.67492 0 0 0 0.51416-0.23778l1.4085 0.84394a0.67492 0.67492 0 0 0 0.01357 0.35095 0.67492 0.67492 0 0 0 0.84519 0.44357 0.67492 0.67492 0 0 0 0.44357-0.84507 0.67492 0.67492 0 0 0-0.84507-0.44357 0.67492 0.67492 0 0 0-0.33812 0.23841l-1.3942-0.83536a0.67492 0.67492 0 0 0 0.02726-0.18998 0.67492 0.67492 0 0 0-0.06225-0.28248l1.5273-1.1466a0.67492 0.67492 0 0 0 0.33016 0.12001 0.67492 0.67492 0 0 0 0.72991-0.61512 0.67492 0.67492 0 0 0-0.61512-0.72978 0.67492 0.67492 0 0 0-0.05042-0.0024z",
    fill: "#e4157f",
    strokeWidth: 0.063841
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.6c933b66b81ea738c79f312151b38d7c.svg";
export { ForwardRef as ReactComponent };